module.exports = __webpack_public_path__ + "static/images/jf-icon.47cb40b.png";